import { memo, useState, useEffect } from 'react';
import Box from '@mui/material/Box';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { calculateDemoResetTime } from 'helpers';
import { 
  Root, 
  ContentWrapper, 
  TimerWrapper, 
  StyledChip, 
  StyledInfoIcon, 
  Title, 
  Subtitle, 
  CloseButton, 
  StyledCloseIcon 
} from './DemoBanner.styled';

const DemoBanner = () => {
  const [dismissed, setDismissed] = useState(false);
  const [timeRemaining, setTimeRemaining] = useState('');

  useEffect(() => {
    setTimeRemaining(calculateDemoResetTime());
    const interval = setInterval(() => setTimeRemaining(calculateDemoResetTime()), 60000);

    return () => clearInterval(interval);
  }, []);

  if (dismissed) return null;

  return (
    <Root>
      <ContentWrapper>
        <StyledInfoIcon />
        <Box>
          <Title variant="body2">Demo Mode</Title>
          <Subtitle variant="body2">Shared environment - avoid entering real personal data</Subtitle>
        </Box>
      </ContentWrapper>
      <TimerWrapper>
        <StyledChip
          icon={<AccessTimeIcon />}
          label={`Resets in ${timeRemaining}`}
          size="small"
        />
      </TimerWrapper>
      <CloseButton aria-label="close" size="small" onClick={() => setDismissed(true)}>
        <StyledCloseIcon />
      </CloseButton>
    </Root>
  );
};

export default memo(DemoBanner);
